import React from 'react';
import usePlayfulStudent from '@/hooks/usePlayfulStudent';
import ComplementaryActivityDetailsDefault from './Default';
import ComplementaryActivityDetailsPlayful from './Playful';

export function ComplementaryActivityDetails(props) {
  const isPlayfulStudentTheme = usePlayfulStudent();

  return isPlayfulStudentTheme ? <ComplementaryActivityDetailsPlayful {...props} /> : <ComplementaryActivityDetailsDefault {...props} />;
}
